import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import comprueboPermisos from "../tools/comprueboPermisos";

const API_UPLOAD =
  "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/persona-item/upload";

const API_GET =
  "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/persona-item/obtiene-persona-item";

const API_DELETE =
  "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/persona-item/borra-persona-item";

const API_EVALUACION =
  "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/getEvaluacionItem";

const API_TOGGLE =
  "https://wwwa.isepsantafe.net.ar/expedientes/ingresos/togglePersonaItem";

const OPCIONES_CARPETA = [
  { id: "completo_apto", texto: "COMPLETO APTO", estado: "aprobado", color: "#16a34a", icono: "✅" },
  { id: "completo_no_apto", texto: "COMPLETO NO APTO", estado: "rechazado", color: "#dc2626", icono: "❌" },
  { id: "con_faltantes", texto: "CON FALTANTES", estado: "cargado", color: "#f59e0b", icono: "⚠️" },
  { id: "no_aporta", texto: "NO APORTA ESTUDIOS", estado: "rechazado", color: "#64748b", icono: "📁" },
];

const identificarResultado = (evaluacion) => {
  const valor = String(evaluacion?.resultado || "").trim().toLowerCase();
  if (["completo_apto", "completo apto", "completo", "apto"].includes(valor)) return "completo_apto";
  if (["completo_no_apto", "completo no apto", "no_apto", "no apto"].includes(valor)) return "completo_no_apto";
  if (["con_faltantes", "con faltantes"].includes(valor)) return "con_faltantes";
  if (["no_aporta", "no_aporta_estudios", "no aporta estudios"].includes(valor)) return "no_aporta";
  // Compatibilidad con registros históricos sin resultado.
  if (evaluacion?.estado === "aprobado") return "completo_apto";
  if (evaluacion?.estado === "rechazado") return "no_aporta";
  // 'cargado' puede ser una simple carga del postulante: no asumir revisión.
  return null;
};

const CarpetaMedicaItem = ({ datos, etapa, refres }) => {
  const Usuario = ObtieneDatosCookies();

  const [files, setFiles] = useState([]);
  const [archivosGuardados, setArchivosGuardados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState("");

  const [selected, setSelected] = useState(null);
  const [observacionAnterior, setObservacionAnterior] = useState("");
  const [observacionNueva, setObservacionNueva] = useState("");
  const [formatoPapel, setFormatoPapel] = useState(false);

  const persona = datos?.persona;
  const persona_id = persona?.dni;
  const proceso_id = datos?.instancia;

  const item = datos?.item;

  const item_id =
    item?.id ||
    item?.item_id ||
    item?.idItem ||
    item;

  const tituloItem =
    item?.descripcion ||
    item?.nombre ||
    "Entrega carpeta médica";

  /* =========================================================
     OBTENER ARCHIVOS GUARDADOS
     ========================================================= */

  const fetchArchivos = async () => {
    try {
      const res = await axios.post(
        API_GET,
        {
          dni: persona_id,
          item_id,
        },
        {
          withCredentials: true,
        }
      );

      setArchivosGuardados(
        res.data?.archivos || []
      );
    } catch (error) {
      console.error(
        "Error obteniendo archivos:",
        error
      );

      console.error(
        "Status:",
        error?.response?.status
      );

      console.error(
        "Respuesta backend:",
        error?.response?.data
      );
    }
  };

  /* =========================================================
     OBTENER EVALUACIÓN EXISTENTE
     ========================================================= */

  const fetchEvaluacion = async () => {
    try {
      const res = await axios.post(
        API_EVALUACION,
        {
          dni: persona_id,
          item_id,
        },
        {
          withCredentials: true,
        }
      );

      const evaluacion =
        res.data?.evaluacion;

      if (!evaluacion) {
        setSelected(null);
        setObservacionAnterior("");
        setObservacionNueva("");
        setFormatoPapel(false);

        return;
      }

             // Recuperar las cuatro opciones y los valores históricos.
       setSelected(identificarResultado(evaluacion));

/* =====================================================
         OBSERVACIONES
         ===================================================== */

      const obs =
        evaluacion.observaciones ||
        "";

      setObservacionAnterior(obs);

      setObservacionNueva("");

             // El historial es acumulativo: tomar el último valor registrado.
       const formatos = [...obs.matchAll(/Formato papel:\s*(SI|SÍ|NO)/gi)];
       setFormatoPapel(
         formatos.length > 0 && /^(si|sí)$/i.test(formatos[formatos.length - 1][1])
       );

    } catch (error) {
      console.error(
        "Error evaluación carpeta médica:",
        error
      );

      console.error(
        "Status:",
        error?.response?.status
      );

      console.error(
        "Respuesta backend:",
        error?.response?.data
      );

      Swal.fire(
        "Error",
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "No se pudo consultar la evaluación de la carpeta médica",
        "error"
      );
    }
  };

  /* =========================================================
     CARGAR DATOS
     ========================================================= */

  useEffect(() => {
    if (
      persona_id &&
      item_id &&
      typeof item_id !== "object"
    ) {
      fetchArchivos();
      fetchEvaluacion();
    }
  }, [persona_id, item_id]);

  /* =========================================================
     SELECCIONAR ARCHIVOS
     ========================================================= */

  const handleChange = (e) => {
    const nuevos =
      Array.from(
        e.target.files || []
      );

    const validos =
      nuevos.filter((file) =>
        [
          "application/pdf",
          "image/jpeg",
          "image/png",
        ].includes(file.type)
      );

    setFiles((prev) => [
      ...prev,
      ...validos,
    ]);
  };

  /* =========================================================
     QUITAR ARCHIVO DE LA COLA
     ========================================================= */

  const removeFile = (index) => {
    const nuevos = [...files];

    nuevos.splice(index, 1);

    setFiles(nuevos);
  };

  /* =========================================================
     SUBIR ARCHIVOS
     ========================================================= */

  const handleUpload = async () => {
    if (!files.length) return;

    setLoading(true);
    setMensaje("");

    try {
      const formData =
        new FormData();

      formData.append(
        "persona_id",
        persona_id
      );

      formData.append(
        "proceso_id",
        proceso_id
      );

      formData.append(
        "item_id",
        item_id
      );

      files.forEach((file) => {
        formData.append(
          "archivos",
          file
        );
      });

      await axios.post(
        API_UPLOAD,
        formData,
        {
          withCredentials: true,

          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      setMensaje(
        "✅ Archivos subidos correctamente"
      );

      setFiles([]);

      await fetchArchivos();

      if (
        typeof refres ===
        "function"
      ) {
        refres();
      }
    } catch (error) {
      console.error(
        "Error subiendo archivos:",
        error
      );

      console.error(
        "Status:",
        error?.response?.status
      );

      console.error(
        "Respuesta backend:",
        error?.response?.data
      );

      setMensaje(
        "❌ Error al subir archivos"
      );

      Swal.fire(
        "Error",
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "No se pudieron subir los archivos",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     BORRAR ARCHIVO
     ========================================================= */

  const handleDelete = async (
    archivo_id
  ) => {
    if (
      !window.confirm(
        "¿Eliminar archivo?"
      )
    ) {
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        API_DELETE,
        {
          archivo_id,
          dni: persona_id,
        },
        {
          withCredentials: true,
        }
      );

      await fetchArchivos();

      if (
        typeof refres ===
        "function"
      ) {
        refres();
      }
    } catch (error) {
      console.error(
        "Error eliminando archivo:",
        error
      );

      console.error(
        "Status:",
        error?.response?.status
      );

      console.error(
        "Respuesta backend:",
        error?.response?.data
      );

      Swal.fire(
        "Error",
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "No se pudo eliminar el archivo",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     GUARDAR CARPETA MÉDICA
     ========================================================= */

  const handleGuardarCarpeta =
    async () => {
      if (!persona) {
        Swal.fire(
          "Error",
          "No hay persona cargada",
          "error"
        );

        return;
      }

      if (
        !item_id ||
        typeof item_id ===
          "object"
      ) {
        Swal.fire(
          "Error",
          "El item_id no es válido",
          "error"
        );

        console.error(
          "ITEM INVÁLIDO:",
          item
        );

        return;
      }

      if (!selected) {
        Swal.fire(
          "Error",
          "Seleccioná uno de los cuatro resultados de carpeta médica",
          "error"
        );

        return;
      }

      const tieneArchivosDigitales =
        archivosGuardados.length > 0;

      const tieneDocumentacion =
        tieneArchivosDigitales ||
        formatoPapel;

             /* =====================================================
          VALIDACIONES
          ===================================================== */

       if (
         ["completo_apto", "completo_no_apto"].includes(selected) &&
         !tieneDocumentacion
       ) {
         await Swal.fire(
           "Atención",
           "Para marcar COMPLETO APTO o COMPLETO NO APTO debe existir documentación digital o física.",
           "warning"
         );
         return;
       }

       if (
         ["completo_no_apto", "con_faltantes", "no_aporta"].includes(selected) &&
         !observacionNueva.trim()
       ) {
         await Swal.fire(
           "Atención",
           "Para este resultado debés registrar una observación.",
           "warning"
         );
         return;
       }

       const opcion = OPCIONES_CARPETA.find((o) => o.id === selected);
       if (!opcion) return;

/* =====================================================
         USUARIO
         ===================================================== */

      const usuarioCarga =
        Usuario
          ? `${Usuario.identificacion} ${Usuario.apellido}, ${Usuario.nombre}`
          : "sistema";

             const estado = opcion.estado;
       const textoResultado = opcion.texto;

/* =====================================================
         NUEVA ACTUALIZACIÓN
         ===================================================== */

      const nuevaActualizacion = `
--- ACTUALIZACIÓN ---
Resultado: ${textoResultado}
Item: ${tituloItem}
Archivos digitales: ${
        tieneArchivosDigitales
          ? "SI"
          : "NO"
      }
Formato papel: ${
        formatoPapel
          ? "SI"
          : "NO"
      }
Observación nueva: ${
        observacionNueva ||
        "Sin observación nueva"
      }
Usuario carga: ${usuarioCarga}
Fecha carga: ${new Date().toLocaleString(
        "es-AR",
        {
          timeZone:
            "America/Argentina/Buenos_Aires",
        }
      )}
`;

      /* =====================================================
         OBSERVACIONES FINALES
         ===================================================== */

      const observacionesFinales =
        [
          observacionAnterior?.trim(),
          nuevaActualizacion.trim(),
        ]
          .filter(Boolean)
          .join("\n\n");

      /* =====================================================
         CONFIRMACIÓN
         ===================================================== */

      const result =
        await Swal.fire({
          title:
            "¿Confirmar carpeta médica?",

          html: `
            <div style="text-align:left">

              <b>Persona:</b>
              ${
                persona.apellido ||
                ""
              },
              ${
                persona.nombre ||
                ""
              }
              (${persona.dni})
              <br/>

              <b>Item:</b>
              ${tituloItem}
              <br/>

              <b>Resultado:</b>
              ${textoResultado}
              <br/>

              <b>Archivos digitales:</b>
              ${
                tieneArchivosDigitales
                  ? "SI"
                  : "NO"
              }
              <br/>

              <b>Formato papel:</b>
              ${
                formatoPapel
                  ? "SI"
                  : "NO"
              }
              <br/>

              <b>Nueva observación:</b>
              ${
                observacionNueva ||
                "Sin observación nueva"
              }
              <br/>

              <b>Usuario:</b>
              ${usuarioCarga}

            </div>
          `,

          icon: "warning",

          showCancelButton: true,

          confirmButtonText:
            "Guardar",

          cancelButtonText:
            "Cancelar",
        });

      if (
        !result.isConfirmed
      ) {
        return;
      }

      /* =====================================================
         PAYLOAD
         ===================================================== */

      const payload = {
        persona_id:
          persona.id ||
          persona.dni,

        proceso_id:
          etapa?.proceso_id ||
          etapa?.etapa_proceso_id ||
          datos?.proceso_id ||
          1,

        item_id:
          Number(item_id),

        tipo: "archivo",

        resultado: selected,

        estado,

        observaciones:
          observacionesFinales,
      };

      /* =====================================================
         GUARDAR
         ===================================================== */

      try {
        setLoading(true);

        const res =
          await axios.post(
            API_TOGGLE,
            payload,
            {
              withCredentials: true,
            }
          );

        console.log(
          "Carpeta médica guardada:",
          res.data
        );

        setObservacionAnterior(
          observacionesFinales
        );

        setObservacionNueva("");

        await Swal.fire(
          "Guardado",
          "Carpeta médica registrada correctamente",
          "success"
        );

        if (
          typeof refres ===
          "function"
        ) {
          refres();
        }
      } catch (error) {
        console.error(
          "Error guardando carpeta médica:",
          error
        );

        console.error(
          "Status:",
          error?.response?.status
        );

        console.error(
          "Respuesta backend:",
          error?.response?.data
        );

        Swal.fire(
          "Error",
          error?.response?.data?.message ||
            error?.response?.data?.error ||
            error.message ||
            "No se pudo guardar la carpeta médica",
          "error"
        );
      } finally {
        setLoading(false);
      }
    };

  /* =========================================================
     SIN DATOS
     ========================================================= */

  if (!datos || !persona) {
    return (
      <div>
        Cargando datos...
      </div>
    );
  }

  /* =========================================================
     RENDER
     ========================================================= */

  return (
    <div style={styles.container}>

      <h3>
        📁 {tituloItem}
      </h3>

      <div style={styles.info}>
        <strong>
          Persona:
        </strong>{" "}
        {persona.apellido},{" "}
        {persona.nombre} - DNI{" "}
        {persona.dni}
      </div>

      <hr />

      {/* =====================================================
          ARCHIVOS GUARDADOS
          ===================================================== */}

      <h4>
        Archivos cargados
      </h4>

      {archivosGuardados.length ===
      0 ? (
        <p
          style={{
            color: "#777",
          }}
        >
          No hay archivos digitales
          subidos.
        </p>
      ) : (
        <div style={styles.lista}>

          {archivosGuardados.map(
            (file) => (
              <div
                key={file.id}
                style={
                  styles.fileItem
                }
              >

                <a
                  href={`https://wwwa.isepsantafe.net.ar${file.url}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  📄 {file.nombre}
                </a>

                {!file.bloqueado &&
                  comprueboPermisos(
                    Usuario?.funcion,
                    "Borro Archivos Postulante"
                  ) && (
                    <button
                      type="button"
                      onClick={() =>
                        handleDelete(
                          file.id
                        )
                      }
                      disabled={
                        loading
                      }
                      style={
                        styles.btnDelete
                      }
                    >
                      ❌
                    </button>
                  )}

              </div>
            )
          )}

        </div>
      )}

      {/* =====================================================
          SELECCIONAR ARCHIVOS
          ===================================================== */}

      <div
        style={styles.uploadBox}
      >
        <label
          style={
            styles.labelUpload
          }
        >
          📎 Seleccionar archivos
          digitales

          <input
            type="file"
            multiple
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={
              handleChange
            }
            style={{
              display: "none",
            }}
          />
        </label>
      </div>

      {/* =====================================================
          ARCHIVOS PENDIENTES
          ===================================================== */}

      {files.length > 0 && (
        <div style={styles.lista}>

          <h5>
            Archivos a subir
          </h5>

          {files.map(
            (file, idx) => (
              <div
                key={idx}
                style={
                  styles.fileItem
                }
              >
                <span>
                  {file.name}
                </span>

                <button
                  type="button"
                  onClick={() =>
                    removeFile(idx)
                  }
                  disabled={
                    loading
                  }
                  style={
                    styles.btnDelete
                  }
                >
                  ❌
                </button>

              </div>
            )
          )}

        </div>
      )}

      {/* =====================================================
          SUBIR
          ===================================================== */}

      <button
        type="button"
        onClick={handleUpload}
        disabled={
          loading ||
          files.length === 0
        }
        style={{
          ...styles.btnSubir,

          opacity:
            loading ||
            files.length === 0
              ? 0.6
              : 1,
        }}
      >
        {loading
          ? "Subiendo..."
          : "Subir archivos"}
      </button>

      {mensaje && (
        <p>
          {mensaje}
        </p>
      )}

      <hr />

      {/* =====================================================
          CARPETA MÉDICA
          ===================================================== */}

      <h4>
        Carpeta médica
      </h4>

      {/* =====================================================
          FORMATO PAPEL
          ===================================================== */}

      <label
        style={
          styles.checkPapel
        }
      >
        <input
          type="checkbox"
          checked={
            formatoPapel
          }
          disabled={loading}
          onChange={(e) =>
            setFormatoPapel(
              e.target.checked
            )
          }
        />

        <span>
          Presentó archivos en
          formato papel
        </span>
      </label>

             {/* =====================================================
           CUATRO RESULTADOS DE CARPETA MÉDICA
           ===================================================== */}

       <div style={styles.botonesEstado}>
         {OPCIONES_CARPETA.map((opcion) => {
           const activo = selected === opcion.id;
           return (
             <button
               key={opcion.id}
               type="button"
               disabled={loading}
               onClick={() => setSelected(opcion.id)}
               aria-pressed={activo}
               style={{
                 ...styles.btnEstado,
                 background: activo ? opcion.color : "#e5e7eb",
                 color: activo ? "#fff" : "#111827",
                 borderColor: activo ? opcion.color : "#cbd5e1",
               }}
             >
               {opcion.icono} {opcion.texto} {activo ? "✓" : ""}
             </button>
           );
         })}
       </div>

       {selected && (
         <div style={styles.resumenResultado}>
           Resultado seleccionado: <strong>{OPCIONES_CARPETA.find((o) => o.id === selected)?.texto}</strong>
         </div>
       )}

{/* =====================================================
          OBSERVACIONES ANTERIORES
          ===================================================== */}

      {observacionAnterior && (
        <div
          style={
            styles.observacionAnterior
          }
        >
          <strong>
            Observaciones anteriores:
          </strong>

          <pre
            style={
              styles.preObs
            }
          >
            {
              observacionAnterior
            }
          </pre>

        </div>
      )}

      {/* =====================================================
          NUEVA OBSERVACIÓN
          ===================================================== */}

      <textarea
        disabled={loading}
        placeholder="Nueva observación / actualización..."
        value={
          observacionNueva
        }
        onChange={(e) =>
          setObservacionNueva(
            e.target.value
          )
        }
        style={
          styles.textarea
        }
      />

      {/* =====================================================
          GUARDAR
          ===================================================== */}

      <button
        type="button"
        onClick={
          handleGuardarCarpeta
        }
        disabled={
          !selected ||
          loading
        }
        style={{
          ...styles.btnGuardar,

          opacity:
            !selected ||
            loading
              ? 0.6
              : 1,
        }}
      >
        {loading
          ? "GUARDANDO..."
          : "GUARDAR CARPETA MÉDICA"}
      </button>

    </div>
  );
};

/* =========================================================
   ESTILOS
   ========================================================= */

const styles = {
  container: {
    border: "1px solid #ddd",
    padding: 18,
    borderRadius: 10,
    maxWidth: "100%",
    width: "100%",
    boxSizing: "border-box",
    background: "#fff",
  },

  info: {
    background: "#f8fafc",
    padding: 10,
    borderRadius: 8,
    marginBottom: 10,
  },

  lista: {
    marginTop: 10,
    marginBottom: 10,
  },

  fileItem: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems: "center",
    background: "#f1f5f9",
    padding: 8,
    borderRadius: 6,
    marginBottom: 6,
    gap: 10,
  },

  uploadBox: {
    marginTop: 12,
    marginBottom: 10,
  },

  labelUpload: {
    display: "inline-block",
    background: "#2563eb",
    color: "#fff",
    padding: "10px 14px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
  },

  btnSubir: {
    padding: "9px 14px",
    borderRadius: 8,
    border: "none",
    background: "#1976d2",
    color: "#fff",
    cursor: "pointer",
  },

  btnDelete: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
  },

  checkPapel: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    marginBottom: 10,
    background: "#f8fafc",
    padding: 10,
    borderRadius: 8,
    border: "1px solid #ddd",
    cursor: "pointer",
    fontWeight: "bold",
  },

  botonesEstado: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
    gap: 10,
    marginBottom: 12,
  },

  resumenResultado: {
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: 8,
    padding: 10,
    marginBottom: 12,
    fontSize: 13,
  },

  btnEstado: {
    padding: "12px 10px",
    minHeight: 65,
    borderRadius: 8,
    border: "2px solid #ccc",
    cursor: "pointer",
    fontWeight: "bold",
  },

  observacionAnterior: {
    background: "#fef9c3",
    border:
      "1px solid #fde68a",
    padding: 10,
    borderRadius: 8,
    marginBottom: 10,
    fontSize: 13,
  },

  preObs: {
    whiteSpace:
      "pre-wrap",
    margin: 0,
    marginTop: 8,
    fontFamily: "inherit",
  },

  textarea: {
    width: "100%",
    minHeight: 110,
    padding: 10,
    borderRadius: 8,
    border:
      "1px solid #ccc",
    resize: "vertical",
  },

  btnGuardar: {
    marginTop: 12,
    width: "100%",
    padding:
      "12px 15px",
    borderRadius: 8,
    border: "none",
    background: "#111827",
    color: "#fff",
    cursor: "pointer",
    fontWeight: "bold",
  },
};

export default CarpetaMedicaItem;